import "rsuite/DateRangePicker/styles/index.css";
import { SettingsPage, SettingsUpdate } from "./settingUpdate";
import { JSONInput } from "./customFields";

export const DEFAULT_IS_PUBLIC = false;

export const ConfigEdit = () => {
    return (
        <SettingsPage title="Config">
            <SettingsUpdate url="/cms/config">
                <JSONInput label="Concerts" source="concerts" />
            </SettingsUpdate>
        </SettingsPage>
    );
};
